exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-7519f3ae] {\n  padding-bottom: 0 !important;\n}\n.image div[data-v-7519f3ae] {\n    position: relative;\n    width: 100%;\n    height: 150px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding-bottom: 0 !important;\n}\n", ""]);

// exports
